module.exports = __webpack_public_path__ + "img/approve-list5.9bb2f13e.png";